import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '@/components/site/Header';
import { Footer } from '@/components/site/Footer';
import { ScrollProgress } from '@/components/site/ScrollProgress';
import { useLenis } from '@/hooks/useLenis';

export function Layout({ children }) {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change (or to hash target)
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // Defer to next frame so target exists
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col bg-ink-bg text-ink-text">
      <ScrollProgress />
      <Header />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}
